<template>
<ul class="pagination">
  <li @click="prev()" :class="{ 'pagination--item': true, 'pagination--chevron': true, 'is-disabled': page == 1 }"><a><i class="icon yule-icon-chevron-left"></i></a></li>
  <li v-for="(number, key) in pages" :key="key" :class="{ 'pagination--item': true, 'is-active': number == page, 'is-diabled': number < 0}">
    <a v-if='number > 0' @click="goToPage(number)">{{number}}</a>
    <a v-else>...</a>
  </li>
  <li @click="next()" :class="{ 'pagination--item': true, 'pagination--chevron': true, 'is-disabled': page == totalPages }"><a><i class="icon yule-icon-chevron-right"></i></a></li>
</ul>
</template>
<script>
import _ from 'lodash'
export default {
  props: {
    page: Number,
    totalPages: Number,
    pagesToDisplay: {
      type: Number,
      default: 3
    }
  },
  computed: {
    pages(){
      let output = []
      if(this.totalPages <= this.pagesToDisplay * 4){
        for (let i=1; i <= this.totalPages; i++){
          output.push(i)
        }
        return output
      }

      for (let i=1; i <= this.pagesToDisplay; i++){
        output.push(i)
      }

      if(this.page > this.pagesToDisplay * 2 + 1){
        output.push(-1)
      }
      if(this.page > this.pagesToDisplay){
        for (let i=(this.page - this.pagesToDisplay); i <= this.page; i++){
          output.push(i)
        }
      }

      if(this.page <= (this.totalPages - this.pagesToDisplay)){
        for (let i= this.page ; i <= (this.page + this.pagesToDisplay); i++){
          output.push(i)
        }
      }

      if(this.page <= this.totalPages - (this.pagesToDisplay * 2 + 1)){
        output.push(-2)
      }

      for (let i=(this.totalPages - this.pagesToDisplay + 1); i <= this.totalPages; i++){
        output.push(i)
      }
      return [ ...new Set(output) ]
    }
  },
  methods: {
    goToPage(number){
      this.$emit('goToPage', number)
    },
    prev(){
      let prev = this.page - 1
      if(prev > 0){
        this.goToPage(prev)
      }
    },
    next(){
      let next = this.page + 1
      if(next <= this.totalPages){
        this.goToPage(next)
      }
    }
  }
}
</script>
<style lang="scss">
.pagination{
  text-align: right;

}
.pagination--item.is-active {
  background-color: $ink-dark !important;
  color: #fff;
  a{
    color: #fff;
  }
}
.pagination--item {
  transition: all .15s ease-out;
  cursor: pointer;
  &:hover {
    background: $paper;
  }

}
.pagination--item.is-disabled {
  opacity: 0.5;
  a {
    cursor: default;
  }
  &:hover {
    background: none;
  }
}
</style>



// WEBPACK FOOTER //
// Pagination.vue?574d65fa